import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
// This is the Angular service that calls the C# REST service
import { DeletedCustomersCountService } from 'src/app/services/deletedCustomersCount/deletedCustomersCount.service';

// These are the supporting files for the component
@Component({
    selector: 'app-deletedCustomersCount-card',
    templateUrl: './deletedCustomersCount-card.component.html',
    styleUrls: ['./deletedCustomersCount-card.component.scss'],
})
export class DeletedCustomersCountCardComponent implements OnInit {

    // This is the Behavior you will reference in the HTML
    deletedCustomersCount$ = new BehaviorSubject<string | undefined>(undefined);

    constructor(
        private _deletedCustomersCountService: DeletedCustomersCountService
    ) {

    }

    ngOnInit() {
        this._deletedCustomersCountService.getDeletedCustomersCount$().subscribe(result => {
            this.deletedCustomersCount$.next(result.scalar);
        });
    }
}
